import * as React from 'react'

const SvgOverflowMenuVerticalIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 5a1.25 1.25 0 100-2.5A1.25 1.25 0 0010 5zm0 6.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zm0 6.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z"
      fill="#163250"
    />
  </svg>
)

export default SvgOverflowMenuVerticalIcon
